import { CheckboxV2, styled } from '@withjoy/joykit';

export const StyledCheckboxV2 = styled(CheckboxV2)``;
